import { HttpHeaders } from '@angular/common/http';
import { Component, OnInit, ViewChild, inject, TemplateRef, Input, OnChanges, SimpleChanges, HostListener } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { debounceTime, distinctUntilChanged, Observable, OperatorFunction, map } from 'rxjs';
import { Utilities } from 'src/app/models/utilities';
import { MobileNumberValidation, EmailValidation } from 'src/app/models/validator';
import { AppCoreService } from 'src/app/services/app-core.service';
import { FileHandlerService } from 'src/app/services/file-handler.service';
import { NotificationsService } from 'src/app/services/notifications.service';
import { AWBService } from 'src/app/services/operations/awb.service';

@Component({
  selector: 'app-updatepod-details',
  templateUrl: './updatepod-details.component.html',
  styleUrls: ['./updatepod-details.component.scss']
})

export class UpdatePODDetails implements OnInit {
  podForm: FormGroup;
  @Input() public cellData: any;
  statusList: any;
  isFormSubmitted = false;
  currentDateTime: any;
  awbNumber: string;
  podId: number;
  awbList: any[] = [];
  remarkList: any[] = [];
  isDelivered = false;
  isDelayed = false;
  isInTransit = false;
  transactionStatus: string;
  currentStatus: any;
  selectedSCId: number;
  podFile: File | null = null;
  isShipmentHold = false;
  isShipmentHoldConfig = false;
  estimatedDeliveryDate: any;
  constructor(
    private appCoreService: AppCoreService,
    public activeModal: NgbActiveModal,
    private ngxLoaderService: NgxUiLoaderService,
    private _fb: FormBuilder,
    private awbService: AWBService,
    private utilities: Utilities,
    private fileHandlerService: FileHandlerService,
    private notificationService: NotificationsService,
    private titleService: Title
  ) {
    titleService.setTitle('Air Way Bill');

  }

  ngOnInit() {
    this.currentDateTime = this.utilities.FormatDateWithTime().dateTimeString;
    this.podForm = this._fb.group({
      txtAwbNo: [null, Validators.required],
      ddlStatus: [this.getAllStatuses(), Validators.required],
      txtExpectedDelvDate: [this.currentDateTime, Validators.required],
      txtReceiverName: [null],
      txtMobileNo: [null, MobileNumberValidation],
      txtRemark: [null, Validators.required],
      customerUploadedFileControl: [],
      txtDays: [null],
      txtHours: [null],
      shipmentHoldDetails: this._fb.group({
        txtEmail: [null, Validators.compose([EmailValidation])]
      })
    });
    if (this.cellData) {
      // this.getAllStatuses();
      this.awbNumber = this.cellData.awbnumber;
      this.estimatedDeliveryDate = this.utilities.FormatDateWithTime(0, this.cellData.estimateddeliverydate).dateTimeString;
      // this.getAwbInfo();
      if (this.awbList.length) {
        this.currentStatus = this.awbList[0].status;
        this.podForm.patchValue({
          txtAwbNo: this.awbList[0].awbnumber
        });
        if (this.currentStatus === 'DELIVERED') {
          this.isDelivered = true;
        }
      }
    }
    this.appCoreService.SelectedServiceCenter().subscribe((val) => {
      this.selectedSCId = val;
    });
    // this.bindPODFields();
    this.getEventConfigs();
    this.getALlRemark();
  }

  @HostListener('document:keyup', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    const daysControl = this.podForm.get('txtDays');
    const hoursControl = this.podForm.get('txtHours');

    if (daysControl.valid && event.key !== 'Backspace' && event.key !== 'Escape' && event.key !== 'Enter' && daysControl?.value?.toString()?.length === 2) {
      this.focusOnHoursInput();
    }
    if (daysControl.valid && event.key === 'Enter' && this.podForm.get('txtDays')?.value?.toString()?.length === 1) {
      this.focusOnHoursInput();
    }
    if (document.activeElement === document.querySelector('input[formControlName="txtHours"]') && hoursControl.valid && hoursControl?.value?.toString()?.length === 2) {
      const nextInput = document.querySelector('input[formControlName="txtRemark"]') as HTMLElement;
      if (nextInput) {
        nextInput.focus();
      }
    }
  }

  private focusOnHoursInput() {
    const hoursInput = document.querySelector('input[formControlName="txtHours"]') as HTMLElement;
    if (hoursInput) {
      hoursInput.focus();
    }
  }

  getRemarkValidator = (isRequired: boolean) => {
    return isRequired ? [Validators.required] : [];
  };
  
  updateRemarkValidator = (isRequired: boolean) => {
    this.podForm.get('txtRemark').setValidators(this.getRemarkValidator(isRequired));
    this.podForm.get('txtRemark').updateValueAndValidity();
  };

  getAllStatuses() {
    this.statusList = [
      {
        id: 1,
        name: 'Delivered'
      },
      {
        id: 2,
        name: 'Returned'
      },
      {
        id: 3,
        name: 'Not Delivered'
      },
      {
        id: 4,
        name: 'Hold'
      },
      {
        id: 5,
        name: 'Void'
      },
      {
        id: 6,
        name: 'Delayed'
      },
      {
        id: 7,
        name: 'In-transit'
      }
    ];
  }

  getAwbInfo() {
    try {
      this.ngxLoaderService.start();
      this.awbService.GetInfo({ awbnumber: this.awbNumber }).subscribe(res => {
        if (res && res?.success) {
          this.ngxLoaderService.stop();
          // console.log(res);
          this.awbList = res.data;

        }
      })
    } catch (e) {
      console.error(e);
      this.ngxLoaderService.stop();
    }
  }

  onAwbChange() {
    const selectedVal = this.podForm.get('txtAwbNo').value;
    this.currentStatus = this.awbList.filter(x => x.awbnumber === selectedVal)[0].status;
  }

  onStatusChange() {
    this.isFormSubmitted = false;
    const transationStatusId = this.podForm.get('ddlStatus').value;
    const status = this.statusList.find((item) => item.id == transationStatusId);
    this.transactionStatus = status?.name;
  
    // Shipment Hold logic
    this.isShipmentHold = status?.name === 'Hold';
    if (!this.isShipmentHold) {
      this.podForm.get('shipmentHoldDetails').reset();
    }
  
    // Delivered
    if (status?.name === 'Delivered') {
      this.isDelivered = true;
      this.isDelayed = false;
      this.isInTransit = false;
  
      this.podForm.get('txtExpectedDelvDate').setValidators([Validators.required]);
      this.podForm.get('txtDays').clearValidators();
      this.podForm.get('txtHours').clearValidators();
    }
    // Delayed
    else if (status?.name === 'Delayed') {
      this.isDelivered = false;
      this.isDelayed = true;
      this.isInTransit = false;
  
      this.podForm.get('txtExpectedDelvDate').clearValidators();
      this.podForm.get('txtDays').setValidators([Validators.max(30)]);
      this.podForm.get('txtHours').setValidators([Validators.max(23)]);
    }
    // In-transit
    else if (status?.name === 'In-transit') {
      this.isDelivered = false;
      this.isDelayed = false;
      this.isInTransit = true;
    }
    // All others
    else {
      this.isDelivered = false;
      this.isDelayed = false;
      this.isInTransit = false;
    }
  
    const isRemarkMandatory = !(this.isDelivered || this.isInTransit);
    this.updateRemarkValidator(isRemarkMandatory);
  
    this.podForm.get('txtExpectedDelvDate').updateValueAndValidity();
    this.podForm.get('txtDays').updateValueAndValidity();
    this.podForm.get('txtHours').updateValueAndValidity();
  }
  

  onSaveClick() {
    if (this.podForm.valid) {
      const transationStatusId = this.podForm.get('ddlStatus').value;
      const email = this.podForm.get('shipmentHoldDetails.txtEmail')?.value;
      const remark = this.podForm.get('txtRemark')?.value;
      const holddetails = {
        email: email
      }
      const requestObj = {
        // id: this.podId,
        generatedfromid: this.selectedSCId,
        awbnumber: this.podForm.get('txtAwbNo')?.value,
        statusupdate: this.statusList.find(item => item.id === transationStatusId).name,
        details: {
          deliverydatetime: this.isDelivered ? this.podForm.get('txtExpectedDelvDate').value : null,
          receiver: this.podForm.get('txtReceiverName')?.value,
          remark: typeof remark === 'object' ? remark?.remark : remark,
          telephone: this.podForm.get('txtTelephoneNo')?.value,
          days: this.podForm.get('txtDays')?.value,
          hours: this.podForm.get('txtHours')?.value,
          fileid: this.podForm.get('customerUploadedFileControl')?.value,
        },
        shipmentholddetails: holddetails ?? null
      }
      if (requestObj.statusupdate === 'Delayed') {
        if (requestObj.details.days === null && requestObj.details.hours === null) {
          return this.appCoreService.showMessage('Either day or hour is required if delayed.', 'Error', 'error');
        }
        requestObj.details.days = !requestObj.details.days ? 0 : requestObj.details.days;
        requestObj.details.hours = !requestObj.details.hours ? 0 : requestObj.details.hours;
      }
      requestObj.details.days = !requestObj.details.days ? 0 : requestObj.details.days;
      requestObj.details.hours = !requestObj.details.hours ? 0 : requestObj.details.hours;
      // console.log('requestObj', requestObj);
      this.ngxLoaderService.start();
      try {
        this.awbService.UpdateStatus(requestObj).subscribe(res => {
          if (res?.success) {
            this.ngxLoaderService.stop();
            // console.log(res);
            this.appCoreService.showMessage('Status updated successsfully', 'Success', 'success');
            this.resetFrom();
            this.activeModal.close('Save Click');

          } else if (res && !res.sucess) {
            this.ngxLoaderService.stop();
            this.appCoreService.showMessage(res.message, 'Error', 'error');
          }
        })
      } catch (error) {
        this.ngxLoaderService.stop();
      }
    }
  }

  status(value: any): string {
    if (!value) {
      return;
    }
    if (typeof value === 'object') {
      value = value?.value;
    }

    let statusHtml = `<span class="badge bg-light">${value}</span>`;
    if (value === 'BOOKED') {
      statusHtml = `<span class="badge bg-light">BOOKED</span>`;
    } else if (value === 'RECEIVED') {
      statusHtml = `<span class="badge bg-primary">RECEIVED</span>`;
    } else if (value === 'PARTIALLY RECEIVED') {
      statusHtml = `<span class="badge bg-primary">PARTIALLY RECEIVED</span>`;
    } else if (value === 'PARTIALLY BAGGED') {
      statusHtml = `<span class="badge bg-info">PARTIALLY BAGGED</span>`;
    } else if (value === 'BAGGED') {
      statusHtml = `<span class="badge bg-info">BAGGED</span>`;
    } else if (value === 'PARTIALLY MANIFESTED') {
      statusHtml = `<span class="badge bg-info">PARTIALLY MANIFESTED</span>`;
    } else if (value === 'MANIFESTED') {
      statusHtml = `<span class="badge bg-info">MANIFESTED</span>`;
    } else if (value === 'SENT') {
      statusHtml = `<span class="badge bg-info">SENT</span>`;
    } else if (value === 'MISROUTED') {
      statusHtml = `<span class="badge bg-danger">MISROUTED</span>`;
    } else if (value === 'OUT FOR DELIVERY') {
      statusHtml = `<span class="badge bg-warning">OUT FOR DELIVERY</span>`;
    } else if (value === 'PARTIALLY DELIVERED') {
      statusHtml = `<span class="badge bg-warning">PARTIAL DELIVERED</span>`;
    } else if (value === 'DELIVERED') {
      statusHtml = `<span class="badge bg-success">DELIVERED</span>`;
    } else {
      statusHtml = `<span class="badge bg-dark">${value?.split('_')[1] || value}</span>`;
    }
    return statusHtml;
  }

  resetFrom() {
    this.isFormSubmitted = false;
    this.podForm.reset();
    this.podForm.get('txtExpectedDelvDate').setValue(this.currentDateTime);
  }

  onChangeFileSelect(evt) {
    try {
      if (evt) {
        this.podFile = evt.target.files[0];
      }
    } catch (e) {
      console.error(e);
    }
  }

  uploadFile() {
    try {
      if (this.podFile) {
        let requestObj = {
          name: this.podFile.name,
          fileType: this.podFile.type,
          category: 'pod'
        };

        // console.log("requestObj : ", requestObj);

        this.fileHandlerService.GetSignedURLForUpload(requestObj).subscribe(res => {
          try {
            if (res && res.success) {
              const signedUrl = res.data.uploadURL;
              const fileId = res.data.fileId;
              if (signedUrl) {
                let headers: HttpHeaders = new HttpHeaders({
                  "Content-Type": requestObj.fileType
                });

                this.fileHandlerService.UploadFile(signedUrl, this.podFile, headers).subscribe((f) => {
                  if (f === null) {
                    // console.log('F', f);
                    this.fileHandlerService.UploadComplete({ id: fileId }).subscribe((res) => {
                      if (res && res.success) {
                        // console.log(res);
                        this.podForm.get('customerUploadedFileControl').setValue(fileId);
                        this.appCoreService.showMessage('File uploaded successfully', 'Success', 'success');
                      }
                    });
                  }
                });
              }
            }
          } catch (error) {
            console.error(error);
          }
        });
      } else {
        this.appCoreService.showMessage('Please select a file to upload', '', 'error');
      }

    } catch (e) {
      console.error(e);
    }
  }

  getEventConfigs() {
    try {
      this.notificationService.GetEventConfigs().subscribe(res => {
        if (res && res?.success) {
          let eventconfiglist = res.data;
          eventconfiglist.forEach((val, idx) => {
            if (val.name === 'TRANSACTION') {
              val.categories.forEach((item, i) => {
                if (item.title === "SHIPMENT_HOLD") {
                  this.isShipmentHoldConfig = item.email;
                }
              })
            }
          })
        }
      })
    } catch (e) {
      console.error(e);
    }

  }

  getALlRemark() {
    this.awbService.GetAllRemark().subscribe(res => {
      if (res && res.success) {
        this.remarkList = res.data;
      }
    })
  }

  searchFormatter = (x: any) => x.remark;

  searchRemark: OperatorFunction<string, readonly { remark; flag }[]> = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map((term) =>
        term === ''
          ? []
          : this.remarkList?.filter((x: any) => x.remark.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10),
      ),
    );

}
